// extracted by mini-css-extract-plugin
export default {"ModalCard":"modal-card_ModalCard__3+THc","cardHeader":"modal-card_cardHeader__I6jGd"};